angular.module('limousineModule').component('limousine', {
	templateUrl: 'limousine/limousine.html',
	bindings: {
		name: '@',
		label: '@',
		model: '<',
		isSearchStyle: '<',
		isRequired: "<",
		simpleFormat: "<",
		noNoMatchesMessage: "<",
		resultsLimit: "<",
		emailUsRpc: '@',
		searchRpc: '@',
		companyPhone: '@',
		searchType: '@',
		buildingName: '@',
		isEnabled: '<',
		errorOnExistance: '<',
		resultList: '<',
		placeholder: '<',
		customTabindex: '@',
		redirectOnItemClick: '<',
		noSpecialChar: '<',
		allUppercase: '<',
		showTotal: '<',
		totalLabel: '@',
		onSelectBuilding: '&',
		onSelectItem: '&',
		onFocus: '&',
		onClose: '&'
	},
	controller: ['$timeout', '$http', '$q', 'PubSub', 'crResourcesService', '$element', function($timeout, $http, $q, PubSub, crResourcesService, $element) {
		var ctrl = this;
		var deferredAbort;
		this.isRequired = (typeof this.isRequired !== "undefined") ? this.isRequired : true;
		this.simpleFormat = (typeof this.simpleFormat !== "undefined") ? this.simpleFormat : false;
		this.noNoMatchesMessage = (typeof this.noNoMatchesMessage !== "undefined") ? this.noNoMatchesMessage : false;
		this.resultsLimit = (typeof this.resultsLimit !== "undefined") ? this.resultsLimit : 0;
		this.noSpecialChar = !!this.noSpecialChar;
		this.errorOnExistance = !!this.errorOnExistance;
		this.searching = false;
		this.search = {
			query: ''
		};
		this.selectedItemIndex = -1;
		this.inputTabindex = this.customTabindex || 0;

		this.handleFocus = function() {
			this.searching = true;

			this.onFocus();
		};

		this.searchSubmit = function() {
			this.resetModel();

			if (this.noNoMatchesMessage && this.simpleFormat) {
				this.model[this.name] = this.search.query;
			}

			if (this.search.query.length === 0 || (this.search.query.length < 3 && this.searchType !== 'unit')) {
				this.showResult = false;
				delete this.resultsItems;

				if (deferredAbort) {
					deferredAbort.resolve();
				}

				return;
			}

			// search from the given result list if resultList exist
			if (this.resultList) {
				this.searchFromResultsList();
			} else {
				this.searchByRpc();
			}
		};

		this.searchFromResultsList = function() {
			this.resultsItems = [];

			angular.forEach(this.resultList, function(item) {
				if (item.toLowerCase() === ctrl.search.query.toLowerCase()) {
					ctrl.resultsItems.push(item);
				}
			});

			this.handleResult();
		};

		this.searchByRpc = function() {
			if (!ctrl.searchRpc) {
				return;
			}

			var rpc = ctrl.searchRpc + (ctrl.searchRpc.indexOf('?') !== -1 ? '&' : '?') + 'rpc=1&query=' + ctrl.search.query;

			// abort the active http request before running a new request.
			if (this.request) {
				this.request.$cancelRequest();
			}
			this.request = crResourcesService.get(rpc);

			this.request.$promise.then(function(response) {
				ctrl.clearSelectedItem();
				if (ctrl.resultsLimit > 0) {
					ctrl.resultsItems = response.data.items.slice(0, ctrl.resultsLimit);
				} else {
					ctrl.resultsItems = response.data.items;
				}

				ctrl.handleResult();
			});

		};

		this.handleResult = function() {
			// if the query doesn't exist, set the value in the model.
			if ((this.errorOnExistance || this.noNoMatchesMessage)  && this.model && this.name) {
				if (this.simpleFormat) {
					this.model[this.name] = this.search.query;
				} else {
					this.model[this.name] = this.search.query;
					this.model[this.name + 'Label'] = this.search.query;
				}
			}

			// for errorOnExistance, if there is no match, we dont display the results
			this.showResult = (this.errorOnExistance && !this.resultsItems.length) ? false : true;

			if (!this.noNoMatchesMessage) {
				// set the error message
				if (!this.resultsItems ||
					(this.resultsItems && !this.resultsItems.length) ||
					(this.resultsItems && this.resultsItems.length && this.errorOnExistance)
				) {
					this.showErrorMessage = true;
				} else {
					this.showErrorMessage = false;
				}
			}
		};

		this.selectItem = function(item) {
			this.search.query = item.label || item.name;

			// set the value in the model
			if (this.model && this.name) {
				if (this.simpleFormat) {
					this.model[this.name] = item.label;
				} else {
					this.model[this.name] = item.id || item.label || item.agent_id;
					this.model[this.name + 'Label'] = item.label || item.name;
					this.model[this.name + 'Obj'] = angular.copy(item);
				}
			}

			// fire the onSelectBuilding if exist
			if (this.onSelectBuilding) {
				this.onSelectBuilding({building: item});
			}

			if (this.onSelectItem) {
				this.onSelectItem({item: item});
			}

			this.clearSelectedItem();
			this.close();

			// cant focus back to input cuz it triggers dropdown display
			const container = $element[0].querySelector('.focus-after-select');
			container && container.focus();
		};

		this.applyModelValue = function() {
			if (ctrl.model[ctrl.name + 'Label']) {
				ctrl.search.query = ctrl.model[ctrl.name + 'Label'];
			} else {
				ctrl.search.query = null;
			}

			// reset the results if the query becomes null
			if (!ctrl.search.query && ctrl.resultsItems) {
				ctrl.showResult = false;
				delete ctrl.resultsItems;
			}
		};

		this.resetModel = function() {
			if (this.model && this.name) {
				if (this.simpleFormat) {
					this.model[this.name] = null;
				} else {
					this.model[this.name] = null;
					this.model[this.name + 'Label'] = null;
					this.model[this.name + 'Obj'] = null;
				}
			}
		};

		this.close = function($event) {
			$event && $event.preventDefault();
			ctrl.searching = false;

			$timeout(function () {
				if (ctrl.searchType === 'unit') {
					// if unit exist, show the error message on rental listing popup
					if (ctrl.search.query && ctrl.resultsItems && ctrl.resultsItems.length) {
						PubSub.publish('rental-listing-show-unit-exist');
					} else {
						PubSub.publish('rental-listing-hide-unit-exist');
					}
				}

				ctrl.onClose();

			});
		};

		this.$postLink = function() {
			// apply the model if exist
			if (this.model && this.model[this.name]) {
				this.applyModelValue();
			}
		};

		if (this.model) {
			// To update the query if the value of the model has changed.
			PubSub.subscribe('updateLimousineQueryByModel-' + this.name, this.applyModelValue);
		}

		this.resetQuery = function() {
			ctrl.search.query = null;
		};

		this.checkKey = function(e) {
			if (this.resultsItems && this.resultsItems.length > 0) {
				if (e.keyCode === 38 || e.keyCode === 40) { // 38-up 40-down
					if (this.selectedItemIndex === -1) {
						this.selectedItemIndex = 0;
					} else {
						this.resultsItems[this.selectedItemIndex].isSelected = false;
						if (e.keyCode === 38 && this.selectedItemIndex > 0) {
							this.selectedItemIndex --;
						} else if (e.keyCode === 40 && this.selectedItemIndex < this.resultsItems.length - 1) {
							this.selectedItemIndex ++;
						}
					}
					this.resultsItems[this.selectedItemIndex].isSelected = true;
				}
			}
		};

		this.clearSelectedItem = function() {
			if (this.resultsItems && this.resultsItems.length > 0) {
				if (this.selectedItemIndex !== -1) {
					this.resultsItems[this.selectedItemIndex].isSelected = false;
					this.selectedItemIndex = -1;
				}
			}
		};

		this.stopEnter = function(e) {
			if (e.keyCode === 13 && this.selectedItemIndex !== -1) { // 13-enter
				e.preventDefault();
				e.stopPropagation();
				this.selectItem(this.resultsItems[this.selectedItemIndex]);
				e.target.blur();
			}
		};

		PubSub.subscribe('resetLimousine-' + this.name, this.resetQuery);
		PubSub.subscribe('closeLimousine-' + this.name, this.close);
	}]
});
